/**
 * Read-more: normal deferred script (not data-src) so the custom element upgrades
 * with the document. Overflow is measured synchronously on connect so the toggle
 * is not delayed by rAF; ResizeObserver batches follow-ups in one rAF for fonts/layout.
 */
(() => {
  if (customElements.get('read-more')) return;

  class ReadMore extends HTMLElement {
    constructor() {
      super();
      this.boundToggleReadMore = this.toggleReadMore.bind(this);
      this._roFrame = null;
    }

    connectedCallback() {
      if (this._readMoreConnected) return;

      this.container = this.querySelector('[data-read-more-wrapper]');
      this.toggleContent = this.querySelector('[data-read-more-content]');
      this.toggleButton = this.querySelector('[data-toggle-text]');
      if (!this.container || !this.toggleContent || !this.toggleButton) return;

      this._readMoreConnected = true;
      this.toggleButton.addEventListener('click', this.boundToggleReadMore);

      this.measureOverflow();

      if (typeof ResizeObserver !== 'undefined') {
        this._resizeObserver = new ResizeObserver(() => {
          if (this._roFrame != null) cancelAnimationFrame(this._roFrame);
          this._roFrame = requestAnimationFrame(() => {
            this._roFrame = null;
            this.measureOverflow();
          });
        });
        this._resizeObserver.observe(this.toggleContent);
      }
    }

    measureOverflow() {
      if (!this.toggleContent || !this.toggleButton) return;
      if (this.container.classList.contains('open')) return;

      this.fullHeight = this.toggleContent.scrollHeight;
      const needsToggle = this.fullHeight > this.toggleContent.clientHeight;
      this.toggleButton.classList.toggle('d-none', !needsToggle);
    }

    toggleReadMore() {
      const isOpen = this.container.classList.contains('open');

      if (isOpen) {
        this.toggleContent.style.maxHeight = this.toggleContent.scrollHeight + 'px';
        this.toggleContent.offsetHeight;
        this.container.classList.remove('open');
        this.toggleContent.style.maxHeight = '';
        this.toggleButton.setAttribute('aria-expanded', 'false');
        setTimeout(() => {
          this.toggleButton.textContent = globalThis.readMoreStrings?.read_more || 'Read More';
        }, 300);
        this.measureOverflow();
      } else {
        this.fullHeight = this.toggleContent.scrollHeight;
        this.toggleContent.style.maxHeight = `${this.fullHeight}px`;
        this.container.classList.add('open');
        this.toggleButton.setAttribute('aria-expanded', 'true');
        setTimeout(() => {
          this.toggleButton.textContent = globalThis.readMoreStrings?.read_less || 'Read Less';
        }, 300);
      }
    }

    disconnectedCallback() {
      this._readMoreConnected = false;
      if (this._roFrame != null) {
        cancelAnimationFrame(this._roFrame);
        this._roFrame = null;
      }
      this.toggleButton?.removeEventListener('click', this.boundToggleReadMore);
      this._resizeObserver?.disconnect();
    }
  }

  customElements.define('read-more', ReadMore);
})();
